import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getAccessToken } from '../../utils/authTokens';

/**
 * Renders children only when the user is authenticated (has access token or user in storage).
 * Otherwise redirects to /login with the current path as return URL.
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const hasToken = !!getAccessToken();
  const hasUser = !!localStorage.getItem('user');

  if (!hasToken && !hasUser) {
    console.info("[Auth] Redirecting to login: no access token and no user in storage (unauthenticated).");
    const from = location.pathname + location.search;
    return <Navigate to={from === '/' ? '/login' : `/login?redirect=${encodeURIComponent(from)}`} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
